import { FC } from 'react';
import { Mosaic } from 'dibs-mosaic/exports/Mosaic';

// constants
import { spacingNumbers as sassySpacingNumbers } from 'dibs-sassy/exports/spacing';
import { AUCTION_MOSAIC_ROW_HEIGHT, MOSAIC_CONFIG } from './SharedRespAuctionMosaicCarousel';

// styles
import itemStyles from './SharedRespAuctionItemTile.scss';
import styles from './SharedRespAuctionMosaicLoading.scss';

export const SharedRespAuctionMosaicLoading: FC = () => (
    <div className={styles.loadingWrapper}>
        <span className={styles.title} />
        <Mosaic
            layout={MOSAIC_CONFIG.layout}
            renderTile={() => {
                return <div className={`${itemStyles.item} ${itemStyles.loading}`} />;
            }}
            gap={sassySpacingNumbers.sassySpacingSmall}
            rowHeight={AUCTION_MOSAIC_ROW_HEIGHT}
        />
    </div>
);
